import { Action, ActionDataEnum, DataItem } from "~/types";

export function getIsFormAutomatic(action: Action) {
  let isFormAutomatic = true;

  if (Array.isArray(action?.data)) {
    const dataItem = (action?.data as DataItem[]).find(
      (item) =>
        (item.key as ActionDataEnum) === ActionDataEnum.IS_FORM_AUTOMATIC,
    );

    if (dataItem) {
      isFormAutomatic = dataItem.value === "1";
    }
  }

  return isFormAutomatic;
}
